<div class="end-to-end">
    <div class="end-to-end__header">
        <div class="end-to-end__details">
            <cds-icon
                class="end-to-end__details-icon"
                shape="switch"
                size="24"
                status="success"
            ></cds-icon>
            <span class="end-to-end__details-description">
                <span class="end-to-end__details-description-title">
                    {{ cardTitle }}
                </span>
            </span>
        </div>
        <div
            class="end-to-end__options"
            *ngIf="canExpand"
        >
            <cds-button
                (click)="toggleExpanded()"
                action="flat"
                class="end-to-end__options-expander-button"
                size="sm"
            >
                <cds-icon
                    class="end-to-end__options-expander"
                    direction="{{ isExpanded ? 'up' : 'down' }}"
                    shape="angle"
                    size="24"
                ></cds-icon>
            </cds-button>
        </div>
    </div>

    <div class="end-to-end__content">
        <end-to-end-knot
            [endToEndKnot]="endToEnd"
            [isExpanded]="isExpanded"
            [canExpand]="canExpand"
            *ngFor="let endToEnd of endToEndList; trackBy: trackByIndex"
        ></end-to-end-knot>
    </div>
</div>
